export const getGoogleMapsRegion = (countryCode) => {
  if (typeof countryCode !== "string" || countryCode.trim() === "") return undefined;

  return countryCode.trim().toUpperCase() === "US" ? undefined : "CA";
};
